import Mural from "./Mural";

export default Mural;
